import React, { ReactElement, useEffect, useState } from "react"
import { 
  PlanType,
  ProductCategory,
  stringToProductCategory, 
} from "../../reducers/models"
import PlansOverview from "./PlansOverview"
//import SimplifiedPlansOverview from "./SimplifiedPlansOverview"
//import PlanFAQ from "../helpers/planFAQ"
import CardSection from "../../components/home/CardSection";
import { cardSectionForProductName } from "../../pages/Home";
import { addPlanToCart } from "../../actions/cart";
import { isMobileDevice } from "../../utils/browserUtils";
import { 
  redirectToDownloads,
  redirectToThankYouPage 
} from "../../utils/routes";
import { useDispatch, useSelector } from "react-redux";
import currentUserInfo from "../../selectors/currentUserInfo";
import PromotionalBanner from "../../components/PromotionalBanner";
import currentSaleContext from "../../selectors/currentSaleContext";
import classnames from "classnames";
import { useHistory } from "react-router-dom";
import { getPlanProvider } from "../../selectors/currentAccountSelector";
import { fetchAccountData, fetchPlanProvider } from "../../actions/account";
import { BB_PAYMENT_PROVIDER_NAMES } from "../../constants/account";
import styles from "../../styles/plans/Plans.module.scss"

import MultiFAQ from "./MultiFAQ"
import stylesSimplified from "../../styles/plans/SimplifiedPlansOverview.module.scss"
import { fetchSale } from "../../actions/sale";

/*
 * Set up the product category (AKA the bb2,bb3,soundbox,etc. buttons) order and initially selected
 * based off of things like the URL path and optional env vars
 */
const DEFAULT_CATEGORY_ORDER = [
  ProductCategory.BB4,
  ProductCategory.BB2,
  ProductCategory.BB3,
  //ProductCategory.Monthly, // monthly plans default disabled 8/24
  ProductCategory.Soundbox,
  ProductCategory.BBBundle
]

const CATEGORY_ORDER:ProductCategory[] = process.env.REACT_APP_PRODUCT_CATEGORY_ORDER !== undefined?
    process.env.REACT_APP_PRODUCT_CATEGORY_ORDER
      .split(",")
      .map(str => str.trim())
      .map(stringToProductCategory)
      .filter(category => category != null) as ProductCategory[]
  :
    DEFAULT_CATEGORY_ORDER

const PATH_NAME_PRODUCT_MAP = {
  "monthly": ProductCategory.Monthly,
  "bb4": ProductCategory.BB4,
  "bb3": ProductCategory.BB3,
  "bb2": ProductCategory.BB2,
  "classic": ProductCategory.BB2,
  "bundle": ProductCategory.BBBundle,
  "soundbox": ProductCategory.Soundbox
}

function getInitialCategory():ProductCategory {
  const lastPath = window.location.pathname.split("/").pop()
  const categoryFromPath:ProductCategory|undefined = PATH_NAME_PRODUCT_MAP[lastPath as keyof typeof PATH_NAME_PRODUCT_MAP]
  return categoryFromPath !== undefined? categoryFromPath : CATEGORY_ORDER[0]
}

export default function Plans(props: any): ReactElement {
  const { homePage } = props
  const dispatch = useDispatch()
  const currentUser = useSelector(currentUserInfo)
  const saleContext = useSelector(currentSaleContext)
  const [selectedCategory, setSelectedCategory] = useState<ProductCategory>(getInitialCategory())
  const history = useHistory()
  const userPlanProvider = useSelector(getPlanProvider)

  
  function handleProductSelected(product: ProductCategory): void {
    if(homePage){
      setSelectedCategory(product)
    } 
    else {
      setSelectedCategory(product)
    }
  }

  async function fetchData() {
    await dispatch(fetchSale());
    await dispatch(fetchAccountData());
  }

  useEffect(() => {
    if(currentUser){
      // update user Plans
      fetchData() 
      dispatch(fetchPlanProvider())
      //setTimeout(() => {
      //  // setIsLoading(false);
      //}, 1200);
    } 
    // eslint-disable-next-line
  },[])

  function handlePurchaseClick(planInfo:bb.model.ISubscription): void {
    const { id:planId, productType, planType } = planInfo
    const isFreePlan = planType === PlanType.Free;

    dispatch(addPlanToCart(planId));

    if (isFreePlan) {
      const isMobile = isMobileDevice();
      if (isMobile) {
        redirectToThankYouPage(props, "freeplan");
      } else {
        if(homePage){
          history.push(`/downloads/${productType.toLowerCase()}`);
        } else {
          redirectToDownloads(props, productType);
        }
      }
    } else {
      const promoCode = sessionStorage.getItem("promoCode");
      const link = promoCode ? `?promo=${promoCode}` : ""
      let defaultLink = "/purchaseThroughStripeCheckout"

      const lowerCaseProduct = productType.toLowerCase() as keyof bb.model.account.IUserPlanProviders;

      if(currentUser){
        if (currentUser?.referralInfo?.Network?.toLowerCase() === "xsolla") {
          defaultLink = "/purchaseThroughXsolla";
        }
        if( userPlanProvider.hasOwnProperty(lowerCaseProduct) ){        
          switch(userPlanProvider[lowerCaseProduct]){
            case BB_PAYMENT_PROVIDER_NAMES.STRIPE:
              defaultLink = "/purchaseThroughStripeCheckout"
              break
            case BB_PAYMENT_PROVIDER_NAMES.ADMIN:
              defaultLink = "/purchaseThroughStripeCheckout"
              break
            case BB_PAYMENT_PROVIDER_NAMES.XSOLLA:
              defaultLink = "/purchaseThroughXsolla"
              break
            default:
              defaultLink = "/purchaseThroughStripeCheckout"
              break
          }  
        } else {
          console.error(`Invalid product type: ${lowerCaseProduct}`);
        }
      } 

      history.push(defaultLink + link);
    }
  }

  return (
    <div className={classnames({[styles.plans]: !homePage, [styles.plansBlackBackground]: homePage})}>
      {!homePage && <PromotionalBanner placement={"website_pricing"} router={props} />}
      <PlansOverview
        {...{selectedCategory}}
        onProductSelected={handleProductSelected}
        categories={CATEGORY_ORDER}
        isLoading={saleContext.showSalesLoader}
        onPurchaseClicked={handlePurchaseClick}
        homePage={homePage}
      />
      {/* <SimplifiedPlansOverview 
        onPurchaseClicked={handlePurchaseClick}
        isLoading={saleContext.showSalesLoader}
      /> */}
       {!homePage && <>
      <div className={stylesSimplified.planFAQ}>
        {/* <PlanFAQ
          styles={styles}
          text={faqTextForProductName(selectedCategory)}
          showTitle={false}
        /> */}
        <MultiFAQ />
      </div>
      <CardSection
        {...cardSectionForProductName(selectedCategory)}
      />
      </>
       }
    </div>
  )
}
